import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Home from '../../pages/Home';
import { IsKioskOnlyAccount, KioskHomePath } from '../../utils/kioskAccount';

/**
 * A raiz ("/") com o desvio do OPERADOR: a conta dos terminais (só
 * `wms:operate`, ver utils/kioskAccount) nunca vê o painel — ela cai direto
 * no posto certo pelo TAMANHO DA TELA, como o dono pediu: 1280×1024 (monitor
 * da bancada) → /bancada; coletor Android → /coletor.
 *
 * A trava de verdade mora no ProtectedRoute (a conta de terminal não sai do
 * posto por rota nenhuma); aqui é a MESMA regra, para a raiz nunca montar o
 * painel nem que a trava mude de lugar.
 */
const OperadorParaQuiosque = () => {
    const { user } = useAuth();
    if (IsKioskOnlyAccount(user?.permissions)) {
        return <Navigate to={KioskHomePath(window.innerWidth)} replace />;
    }
    return <Home />;
};

export default OperadorParaQuiosque;
